import * as sentry from '@sentry/react';
import {call, put, select, takeLatest} from 'redux-saga/effects';

import {config} from 'config/env';
import {getUserAddresses} from 'services/user/user-service';
import {
  fetchUserAddressesAction,
  setUserAddressesAction,
  updateBasketAddressAction,
  setSelectedAddressAction
} from 'store/actions/addresses-action';
import {AddressesState} from 'store/types/addresses';
import {AppState} from 'store/types/app';
import {AddressTypeEnum, IDefaultUserAddressesResponse} from 'types';
import {fetchShippingAddress, isSyncAddressEnabled} from 'utils/helper';

function* fetchUserAddressesSaga(): Generator {
  const accessToken = yield select((state) => state.auth?.idToken);
  try {
    const response = (yield call(() =>
      getUserAddresses(
        accessToken as string,
        !config.IS_REMOVE_ADDRESS_TYPE_ENABLED ? AddressTypeEnum.SHIPPING : undefined
      )
    )) as {
      data: IDefaultUserAddressesResponse;
    };
    const availableAddresses = response?.data?.getUserAddresses || [];
    yield put(setUserAddressesAction(availableAddresses));
  } catch (e: any) {
    const extra = {idToken: accessToken};
    sentry.captureException(e, {extra});
  }
}

function* updateBasketAddressesSaga(): Generator {
  try {
    const {availableAddresses, selectedShippingAddress} = (yield select(
      (state) => state.addresses
    ) as unknown) as AddressesState;

    const {currentStore} = (yield select((state) => state.app) as unknown) as AppState;
    const isSyncAddress = isSyncAddressEnabled();
    let relevantAddress;

    if (isSyncAddress) {
      relevantAddress = fetchShippingAddress(availableAddresses, currentStore);
    } else {
      const savedAddressId = localStorage.getItem('selectedShippingAddressId');
      const savedAddress = availableAddresses.find((address) => savedAddressId && address.id === savedAddressId);
      if (
        savedAddress &&
        savedAddress.zip === currentStore?.zipcode &&
        (savedAddress.subDistrict?.nameEn === currentStore.subdistrict ||
          savedAddress.subDistrict?.nameTh === currentStore.subdistrict)
      ) {
        relevantAddress = savedAddress;
      } else if (!selectedShippingAddress?.id) {
        relevantAddress = fetchShippingAddress(availableAddresses, currentStore);
      }
      localStorage.setItem('selectedShippingAddressId', relevantAddress?.id || '');
    }
    yield put(setSelectedAddressAction(relevantAddress));
  } catch (e: any) {
    sentry.captureException(e);
  }
}

export default function* () {
  yield takeLatest(fetchUserAddressesAction, fetchUserAddressesSaga);
  yield takeLatest(updateBasketAddressAction, updateBasketAddressesSaga);
}
